import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { LenderIdentityApi, LenderIdentity } from '../tokens/lender-identity.token';

/**
 * REST-only implementation of {@link LenderIdentityApi} (EM-713 / P1).
 *
 * Calls:
 *   GET /services/embedded/api/v1/lender/identity → {@link LenderIdentity}
 *
 * This is the authoritative server-side resolution of the lender's display title +
 * typology (replacing the static `ssoTitles` maps). Rides the Keycloak bearer via
 * `authInterceptor`. Rule 07/10 — no mock fallback. Playwright intercepts via `page.route()`.
 */
@Injectable()
export class LenderIdentityRestService implements LenderIdentityApi {
  private readonly http = inject(HttpClient);
  private readonly url = `${API_PATHS.LENDER_IDENTITY}`;

  getIdentity(): Observable<LenderIdentity> {
    return this.http.get<LenderIdentity>(this.url);
  }
}
